import { render } from "./footerHtml.vue?vue&type=template&id=4385de91&scoped=true"
const script = {}

import "./footerHtml.vue?vue&type=style&index=0&id=4385de91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4385de91"]])

export default __exports__